import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { ManGender } from './svg/manGender';

export const ManGenderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ManGender} {...props} />
);
